require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./marion-county-jail-reentry-program.json") })
        }
      }, "path---marion-county-jail-reentry-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---marion-county-jail-reentry-program!./.cache/json/marion-county-jail-reentry-program.json
// module id = 929
// module chunks = 231608221292675